import * as React from 'react';

const SvgCustomKor = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 320 213'
		style={{
			enableBackground: 'new 0 0 320 213',
		}}
		xmlSpace='preserve'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<image
			id='image0'
			width='320'
			height='213'
			x='0'
			y='0'
			href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAADVCAIAAACpLr65AAAABGdBTUEAALGPC/xhBQAAACBjSFJN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'
		/>
	</svg>
);

export default SvgCustomKor;
